export const DONATION_SEARCH_PLACEHOLDERS = {
  donationId: "Search by donation ID",
  currency: "Search by currency",
} as const

export const DONATION_TYPE_DISPLAY = {
  guest: { label: "Guest", color: "gold" },
  member: { label: "Member", color: "blue" },
} as const
